






















































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';
import { AxiosError } from 'axios';
import { mapState } from 'vuex';

import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import FormInput from '@/components/FormInput.vue';
import Select from '@/components/Select.vue';
import Toggle from '@/components/Toggle.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';

import PermissionTree from '@/components/PermissionTree/PermissionTree.vue';
import api from '@/libs/api';
import {
  PermissionApiResponse,
  Group,
  GroupApiResponse,
  UserRoleApiResponse,
  Role,
  GroupRolesApiResponse,
  ErrorItem,
  UserDetail,
  User,
} from '@/libs/api.interfaces';
import hasPermission from '@/libs/permission';
import { ToastType } from '@/store/toast';
import { showToast } from '@/libs/toast';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    FormInput,
    Select,
    PermissionTree,
    Toggle,
    Button,
    Loader,
    ValidationObserver,
  },
  methods: {
    hasPermission,
  },
  computed: mapState(['user']),
})
export default class UserEditor extends Vue {
  user!: {
    user: User;
  };

  selectedMerchants: { id: number; merchant_code: string; merchant_name: string } | null = null;
  type = '';
  isEdit = false;
  detailPermissionProcessed = false;
  name = '';
  email = '';
  role: number | null = null;
  group: Group | null = null;
  groupExternal = -1;
  loading = false;
  loadingPermission = false;
  loadingSubmit = false;
  status = false;
  loadingMerchant = false;
  rolePermission: string[] = [];
  roleDetailPermission: string[] = [];
  basePermission: PermissionItem[] = [];
  permissions: PermissionItem[] = [];
  groups: Group[] = [];
  roles: Role[] = [];
  rolesExternal: Role[] = [];

  roleFilter: { id: number; role: string } | null = null;

  errors = {
    name: '',
    email: '',
    group: '',
    role: '',
    selectedMerchants: '',
  }

  merchants = [
    {
      /* eslint-disable @typescript-eslint/camelcase */
      merchant_code: '',
      merchant_name: 'Enter merchant name',
      $isDisabled: true,
      id: '',
      /* eslint-enable @typescript-eslint/camelcase */
    },
  ];

  hasPermission!: (val: string | string[]) => boolean;

  async mounted() {
    this.type = this.$route.params.type;

    if (this.type !== 'internal' && this.type !== 'external') this.$router.back();
    this.isEdit = this.$route.name === 'UserEdit';

    if (this.type === 'internal') await this.getPermissions();
    await this.getGroups();

    if (this.type === 'external') {
      await this.getGroups();
      this.groups.forEach(async (g: Group) => {
        await this.getExternalRoles(g.id);
      });
      this.status = true;
      this.roles = this.rolesExternal;
    }

    if (this.isEdit) {
      this.getUserDetail();
    }
  }

  @Watch('selectedMerchants')
  async onSelectedMerchantsChange() {
    // console.log(this.selectedMerchants);
    // if (this.type === 'external') {
    //   console.log(this.role);
    //   if (this.selectedMerchants?.merchant_code !== '') {
    //     await this.getPermissions();
    //   }
    //   if (this.role === null || this.group === null) return;
    //   if (this.user.user.is_internal !== 0 && this.role !== null) {
    //     await this.getRolePermission(this.role);
    //   }
    // }
    await this.onRoleChange();
  }

  @Watch('group')
  async onGroupChange(value: Group, oldValue: Group | null) {
    if (this.group === null) {
      this.roleFilter = null;
      return;
    }
    if (oldValue !== null) {
      this.roleFilter = null;
    }
    await this.getRoles(this.group.id);
  }

  @Watch('role')
  async onRoleChange() {
    if (this.role === null || (this.group === null && this.type === 'internal')) return;
    if (this.type === 'external' && this.role !== null) {
      await this.getPermissions();
    }
    if (this.type === 'external' && this.user.user.is_internal === 0) {
      await this.getPermissions();
    }
    await this.getRolePermission(this.role);
    this.groupExternal = this.rolesExternal.find((e) => e.id === this.role)?.user_group_id || -1;
  }

  @Watch('roleFilter')
  async onRoleFilterChange() {
    this.role = this.roleFilter?.id || null;
  }

  private async getUserDetail() {
    try {
      const { data } = await api.get<UserDetail>(`/user/${this.$route.params.id}`);

      if (this.isEdit) {
        this.selectedMerchants = data.merchant;
      }

      if (this.type === 'internal') {
        this.group = data.user_role.user_group;
      }

      this.roleFilter = {
        id: data.user_role.id,
        role: data.user_role.role,
      };
      this.role = data.user_role.id;
      this.status = data.status === 'ACTIVE';
      this.name = data.name;
      this.email = data.email;
      this.roleDetailPermission = data.user_permission.permission;
    } catch (err) {
      console.error(err);
      const error = err as AxiosError;
      showToast(ToastType.FAILED, `Error ${error.response?.status}`, 'Failed to get user detail');
    }
  }

  async getMerchants(query: string) {
    if (query === '') return;

    try {
      this.loadingMerchant = true;
      const { data } = await api.get('/merchants-sd', {
        params: {
          name: query,
        },
      });
      this.merchants = data.data;
      this.loadingMerchant = false;
    } catch (err) {
      console.error(err);
    }
  }

  private async submit() {
    this.errors = {
      name: '',
      email: '',
      group: '',
      role: '',
      selectedMerchants: '',
    };

    if (this.name === '') {
      this.errors.group = 'Name cannot be empty';
      return;
    }

    if (this.email === '') {
      this.errors.group = 'Email cannot be empty';
      return;
    }

    if (this.group === null && this.type === 'internal') {
      this.errors.group = 'Please select group first';
      return;
    }

    if (this.role === null) {
      this.errors.group = 'Please select role first';
      return;
    }

    if (this.selectedMerchants === null) {
      if (this.type === 'external') {
        this.errors.selectedMerchants = 'Please select merchant first';
      }
    }

    const permissions = this.flattenPermission(this.permissions as PermissionItemCheck[]);
    try {
      this.loadingSubmit = true;

      /* eslint-disable @typescript-eslint/camelcase */
      await api({
        method: this.isEdit ? 'PUT' : 'POST',
        url: `/user${this.isEdit ? `/${this.$route.params.id}` : ''}`,
        data: {
          email: this.email,
          name: this.name,
          is_internal: this.type === 'internal',
          user_group_id: this.group === null ? this.groupExternal : this.group.id,
          user_role_id: this.role,
          user_permission: permissions,
          status: this.status,
          merchant_id: this.selectedMerchants ? this.selectedMerchants.id : undefined,
          merchant_code: this.selectedMerchants ? this.selectedMerchants.merchant_code : undefined,
        },
      });
      /* eslint-enable @typescript-eslint/camelcase */
      this.loadingSubmit = false;
      showToast(ToastType.SUCCESS, 'Congratulations', `User has been ${this.isEdit ? 'updated' : 'created'}`);
      this.$router.push(`/setting/user-management/${this.type}/users`);
    } catch (err) {
      this.loadingSubmit = false;
      console.error(err);
      const error = err as AxiosError;

      if (error.response?.status === 400) {
        showToast(ToastType.FAILED, 'Oops... Sorry', 'Please check all the field');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (err as any).response.data.error.errors.forEach((item: ErrorItem) => {
          if (item.reason === 'EmailAlreadyTakenException') {
            this.errors.email = item.message;
          }
        });
      } else {
        showToast(ToastType.FAILED, `Error ${error.response?.status}`,
          `Failed to ${this.isEdit ? 'updated' : 'created'} the user`);
      }
    }
  }

  get typeTitle() {
    return this.type ? `${this.type[0].toUpperCase()}${this.type.substring(1)}` : '';
  }

  private async getPermissions() {
    try {
      this.loadingPermission = true;
      let mcode = {};
      if (this.$route.params.type === 'external' && this.selectedMerchants?.merchant_code !== '') {
        // eslint-disable-next-line @typescript-eslint/camelcase
        mcode = { merchant_code: this.selectedMerchants?.merchant_code };
      }
      const { data } = await api.get<PermissionApiResponse>('/permissions', {
        params: {
          // eslint-disable-next-line @typescript-eslint/camelcase
          is_internal: this.$route.params.type === 'internal',
          ...mcode,
        },
      });
      const permissions = data.data;
      if (permissions) {
        this.basePermission = permissions;
        this.permissions = permissions;
      }
      this.loadingPermission = false;
    } catch (err) {
      console.error(err);
      const error = err as AxiosError;
      showToast(ToastType.FAILED, `Error ${error.response?.status}`, 'Failed to get permission list');
    }
  }

  private async getRoles(id: number) {
    try {
      this.loadingPermission = true;
      const { data } = await api.get<GroupRolesApiResponse>(`/user-group/${id}/roles`);
      const ext = data.data.items
        .filter((e: Role) => e.status === 'ACTIVE')
        .sort((a, b) => a.role.localeCompare(b.role));
      // this.roles = data.data.items;
      this.roles = ext;
      this.loadingPermission = false;
    } catch (err) {
      this.loadingPermission = false;
      console.error(err);
      const error = err as AxiosError;
      showToast(ToastType.FAILED, `Error ${error.response?.status}`, 'Failed to get role list');
    }
  }

  private async getExternalRoles(id: number) {
    try {
      this.loadingPermission = true;
      const { data } = await api.get<GroupRolesApiResponse>(`/user-group/${id}/roles`);
      this.rolesExternal.push(...data.data.items);
      const ext = this.rolesExternal
        .filter((e: Role) => e.status === 'ACTIVE')
        .sort((a, b) => a.role.localeCompare(b.role));
      this.rolesExternal.length = 0;
      this.rolesExternal.push(...ext);
      this.loadingPermission = false;
    } catch (err) {
      this.loadingPermission = false;
      console.error(err);
      const error = err as AxiosError;
      showToast(ToastType.FAILED, `Error ${error.response?.status}`, 'Failed to get role list');
    }
  }

  private async getGroups() {
    try {
      this.loading = true;
      const { data } = await api.get<GroupApiResponse>('/user-groups');
      this.groups = data.data.items.filter((e) => e.is_internal === (this.type === 'internal' ? 1 : 0));
      this.loading = false;
    } catch (err) {
      console.error(err);
      const error = err as AxiosError;
      showToast(ToastType.FAILED, `Error ${error.response?.status}`, 'Failed to get group list');
    }
  }

  private async getRolePermission(id: number) {
    try {
      this.loadingPermission = true;
      this.permissions = [];
      const { data } = await api.get<UserRoleApiResponse>(`/user-role/${id}/permissions`);
      this.rolePermission = data.data.items.permission;
      this.permissions = this.checkPermission(this.basePermission as PermissionItemCheck[]);

      if (!this.detailPermissionProcessed && this.isEdit) {
        this.permissions = this.checkPermissionView(this.permissions as PermissionItemCheck[]);
        // this.detailPermissionProcessed = true;
      }
      this.loadingPermission = false;
    } catch (err) {
      console.error(err);
      showToast(ToastType.FAILED, 'Error', 'Failed to get role permissions');
    }
  }

  private checkPermission(child: PermissionItemCheck[]) {
    const newPermissionsValue = [...child];
    return newPermissionsValue.reduce((prev, p) => {
      const perm = { ...p };
      if (perm.child) {
        perm.child = this.checkPermission(perm.child as PermissionItemCheck[]);
      }

      if (this.rolePermission.includes(perm.value)) {
        perm.checkValue = 'CHECKED';
      }

      if (perm.checkValue !== undefined
        || (perm.child !== undefined && perm.child.length !== 0)) {
        prev.push(perm);
      }

      return prev;
    }, [] as PermissionItemCheck[]);
  }

  private checkPermissionView(child: PermissionItemCheck[]) {
    const newPermissionsValue = [...child];
    return newPermissionsValue.map((p) => {
      const perm = { ...p };
      if (perm.child) {
        perm.child = this.checkPermissionView(perm.child as PermissionItemCheck[]);
      }

      if (this.roleDetailPermission.includes(perm.value)) {
        perm.checkValue = 'CHECKED';
      } else {
        perm.checkValue = 'UNCHECKED';
      }

      return perm;
    }, [] as PermissionItemCheck[]);
  }

  private flattenPermission(child: PermissionItemCheck[]) {
    return child.reduce((prev: string[], p) => {
      if (p.child) {
        prev.push(...this.flattenPermission(p.child as PermissionItemCheck[]));
      }

      if (p.checkValue === 'CHECKED' || p.checkValue === 'PARTIAL') {
        prev.push(p.value);
      }

      return prev;
    }, []);
  }
}
